import { render } from "./AiRelay.vue?vue&type=template&id=11ec6b21"
import script from "./AiRelay.vue?vue&type=script&lang=js"
export * from "./AiRelay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__